import Debounce from '../Utils/Debounce';

const mobileSize = 768;

function updateHeroVids() {
	document.querySelectorAll('.js-hero').forEach(hero => {
		const vidEl = hero.querySelector('.js-hero-vid');
		if (!vidEl) return;

		const vidSourceEl = vidEl.querySelector('source');
		const imgEl = hero.querySelector('.js-hero-img');

		if (window.innerWidth > mobileSize) {
			vidSourceEl.src = vidSourceEl.dataset.src;
			vidEl.classList.remove('hidden');
			imgEl.classList.add('hidden');
			vidEl.load();
			vidEl.play();
		} else {
			vidEl.classList.add('hidden');
			imgEl.classList.remove('hidden');
			vidEl.pause();
		}
	});
}

updateHeroVids();
window.addEventListener('resize', Debounce(updateHeroVids, 250));
